import { makeDefaultUiParams as makeDefaultMyListingsUiParams } from "containers/MyListings/filters/constants";
import { makeDefaultUiParams as makeDefaultOpenListingsUiParams } from "containers/OpenListings/filters/constants";
import { makeDefaultUiParams as makeDefaultPastDealsUiParams } from "containers/PastDeals/filters/constants";
import { initializeQueryParams } from "hooks/useQueryParams";
import { makeQueryString } from "lib/dynamicRest";

import { SocialProviders } from "./types";

// Params

const ORDER_FILL_ID = ":orderFillId";
const LISTING_ID = ":listingId";
const VALUATION_ID = ":valuationId";

// Overview

export const overview = () => "/overview";

// Directory

export const directory = () => "/accounts";

export const directoryBuyerDashboard = () =>
  `${directory()}/orderbook/buyer-dashboard/`;

export const directoryLogin = () => `${directory()}/login/`;

export const directoryLogout = () => `${directory()}/logout/`;

export const directorySignUp = () => `${directory()}/signup/`;

export const directoryFinalizeSetup = () => `${directory()}/user-setup`;

export const directorySignInOrRegister = () =>
  `${directory()}/signin-or-register/`;

export const directoryEmailVerificationSent = () =>
  `${directory()}/confirm-email/`;

export const directoryProfile = () => `${directory()}/profile/`;

export const directoryChangePassword = () => `${directory()}/password/change`;

export const directorySocialLogin = (provider: SocialProviders) =>
  `${directory()}/${provider}/login/`;

export const smsNotificationsOptIn = () => `${directory()}/sms-notifications/`;

// Order Book
// Utilities
export const orderBook = () => "/orderbook";

// Exchange
export const orderBookMyListingsNoParams = () => `${orderBook()}/my-listings/`;
export const orderBookMyListings = (userId: number) =>
  `${orderBookMyListingsNoParams()}?${makeQueryString(
    initializeQueryParams(makeDefaultMyListingsUiParams(userId, false)),
  )}`;
export const orderBookOpenListingsNoParams = () =>
  `${orderBook()}/open-listings/`;
export const orderBookOpenListings = (userId: number) =>
  `${orderBookOpenListingsNoParams()}?${makeQueryString(
    initializeQueryParams(makeDefaultOpenListingsUiParams(userId, false)),
  )}`;
export const orderBookPastDealsNoParams = () => `${orderBook()}/past-deals/`;
export const orderBookPastDeals = (userId: number) =>
  `${orderBookPastDealsNoParams()}?${makeQueryString(
    initializeQueryParams(makeDefaultPastDealsUiParams(userId, false)),
  )}`;
export const orderBookAssetDetail = (listingId = LISTING_ID) =>
  `${orderBook()}/asset-detail/${listingId}`;
export const orderBookAssetDetailPreview = (listingId = LISTING_ID) =>
  `${orderBook()}/asset-detail/${listingId}/preview`; // for matching the modal
export const orderBookDealPage = () => `${orderBook()}/deal-page/`;

// Buyer
export const orderBookBuyerDashboard = () => `${orderBook()}/buyer-dashboard/`;
export const orderBookOrderFill = (orderFillId = ORDER_FILL_ID) =>
  `${orderBook()}/order-fill/${orderFillId}`;
export const orderBookPay = (token = ":token") => `${orderBook()}/pay/${token}`;
export const orderBookVerify = () => `${orderBook()}/verify/`;

// Order Book Seller
// Utilities
export const seller = () => "/seller";
export const sellerLogout = () => `${seller()}/logout/`;
export const sellerNotFound = () => `${seller()}/404/`;

// Create account/login
export const sellerCreateAccount = () => `${seller()}/create-account/`;
export const sellerCreateAccountReferral = () =>
  `${seller()}/create-account-referral/`;
export const sellerCompleteAccount = () => `${seller()}/complete-account/`;
export const sellerLogin = () => `${seller()}/login/`;

// Dashboard
export const sellerDashboard = () => `${seller()}/dashboard`;

// Connect routes
export const sellerAboutDealOptions = () => `${seller()}/about-deal-options`;
export const sellerAddRoyaltyAccount = () => `${seller()}/add-royalty-account`;
export const sellerValuationLoading = () => `${seller()}/valuation-loading/`;
export const sellerValuationResults = (valuationId = VALUATION_ID) =>
  `${seller()}/valuation-results/${valuationId}`;

// Document upload
export const sellerDocumentUpload = () => `${seller()}/document-upload/`;

// Preview
export const preview = () => `/orderbook/preview`;
export const previewListingDeprecated = (listingId = LISTING_ID) =>
  `${preview()}/listing/${listingId}`;
export const previewOrderFill = (orderFillId = ORDER_FILL_ID) =>
  `${preview()}/order_fill/${orderFillId}`;
export const previewValuation = (valuationId = VALUATION_ID) =>
  `${preview()}/valuation/${valuationId}`;
export const previewValuationLoading = () => `${preview()}/valuation-loading/`;

// Admin

export const admin = () => `/admin`;
export const adminLogin = () => `${admin()}/login/`;
